var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",on:{"scroll":_vm.handleScroll}},[_vm._v(" 666 "),_vm._l((_vm.contentArray),function(item,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContent[index]),expression:"showContent[index]"}],key:index,staticClass:"content"},[_vm._v(" "+_vm._s(item)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }